(async () => {
    const { Core } = await importModule('Core');
    const { fetchHTML, $replaceContent } = await importModule('Utils');

    customElements.define('collection-provider', class extends Core {

        elements = {
            form: '[data-collection-form]',
            drawerForm: '[data-collection-drawer-form]',
            dynamicBlocks: '*[data-collection-dynamic-block]'
        }

        subscriptions = {
            'filter:change': '_onFilterChange',
            'navigation:change': '_onFilterChange'
        }

        cache = {};

        render() {
            this.subscribe('filter:change');
            this.subscribe('navigation:change');
            this.addEventListener('click', this._handleClicks.bind(this));
        }

        _handleClicks(e) {
            const loadMoreBtn = e.target.closest('[data-load-more-btn]');
            if (loadMoreBtn) {
                e.preventDefault();
                this._handleLoadMore(loadMoreBtn);
                return;
            }

            const backToTopBtn = e.target.closest('[data-back-to-top-btn]');
            if (backToTopBtn) {
                e.preventDefault();
                this._scrollToTop();
                return;
            }
        }

        async _handleLoadMore(btn) {
            if (this.isLoadingMore) return;
            this.isLoadingMore = true;

            const url = btn.getAttribute('href');
            if (!url) {
                this.isLoadingMore = false;
                return;
            }

            btn.classList.add('is-loading');
            const originalText = btn.textContent;
            btn.textContent = 'Loading...';

            // Construct URL with section_id parameter to only fetch the collection section HTML
            const urlObj = new URL(url, window.location.origin);
            urlObj.searchParams.set('section_id', this.sectionId);
            const fetchUrl = urlObj.toString();

            try {
                this.publish('collection:loading');
                const doc = await fetchHTML(fetchUrl);

                // 1. Append products
                const container = this.querySelector('[data-products-container]');
                const newContainer = doc.querySelector('[data-products-container]');
                if (container && newContainer) {
                    Array.from(newContainer.children).forEach(child => {
                        container.appendChild(child);
                    });
                }

                // 2. Replace pagination block
                const pagination = this.querySelector('[data-collection-pagination]');
                const newPagination = doc.querySelector('[data-collection-pagination]');
                if (pagination && newPagination) {
                    pagination.parentNode.replaceChild(newPagination, pagination);
                } else if (pagination) {
                    const newProgress = doc.querySelector('.collection-load-more-progress');
                    if (newProgress) {
                        const progress = this.querySelector('.collection-load-more-progress');
                        if (progress) {
                            progress.parentNode.replaceChild(newProgress, progress);
                        }
                    }
                    btn.style.display = 'none';
                }

                // 3. Update history URL (removing page and section_id parameters for clean infinite scroll refresh behavior)
                const cleanUrl = new URL(url, window.location.origin);
                cleanUrl.searchParams.delete('page');
                cleanUrl.searchParams.delete('section_id');
                window.history.pushState({}, null, cleanUrl.pathname + cleanUrl.search);

                this.publish('collection:updated', {
                    doc: doc
                });

            } catch (error) {
                console.error('Error loading more products:', error);
                btn.textContent = originalText;
                btn.classList.remove('is-loading');
            } finally {
                this.isLoadingMore = false;
            }
        }

        async _onFilterChange(data) {
            this._getUrlParams(data);
            this._updateHistory();
            this._scrollToTop();
            await this._updateDynamicBlocks();
        }

        _getUrlParams(data) {
            this.urlParams = data?.url
                ? new URL(`${window.location.origin}${data.url}`).searchParams
                : new URLSearchParams(new FormData(this.$currentForm));
        }

        _updateHistory() {
            window.history.pushState({}, null, `${window.location.pathname}?${this.urlParams.toString()}`);
        }

        async _updateDynamicBlocks() {
            await this._getDoc();
            this.$dynamicBlocks.map($block => {
                $replaceContent(
                    $block,
                    this.doc.getElementById($block.id)
                );
            });

        }

        async _getDoc() {
            const urlParamsStr = this.urlParams.toString();
            if (this.cache[urlParamsStr]) {
                this.doc = this.cache[urlParamsStr];
            } else {
                this.publish('collection:loading');
                await this._fetchDoc(urlParamsStr);
            }
            this.publish('collection:updated', {
                doc: this.doc
            })
        }

        async _fetchDoc(urlParamsStr) {
            const fetchParams = new URLSearchParams(urlParamsStr);
            fetchParams.append('section_id', this.sectionId);
            this.doc = await fetchHTML(`${this.getAttribute('collection-url')}?${fetchParams.toString()}`);
            this.cache[urlParamsStr] = this.doc;
        }

        _scrollToTop() {
            window.scrollTo({
                top: this.topPoint,
                behavior: 'smooth',
            });
        }

        get topPoint() {
            const headerHeight = document.documentElement.style.getPropertyValue('--header-height')?.replace('px', '');
            return headerHeight ? this.offsetTop - headerHeight : this.offsetTop;
        }

        get $currentForm() {
            if (!this.$form) {
                return this.$drawerForm;
            }
            return this.onMobile ? this.$drawerForm : this.$form;
        }

        get onMobile() {
            return window.matchMedia('(max-width: 992px)').matches;
        }
    })
})();
